export default [
	{
		name: 'Digital Marketing',
		id: 1,
		selected: false,
	},
	{
		name: 'Affiliate Marketing',
		id: 2,
		selected: false,
	},
	{
		name: 'Social Media',
		id: 3,
		selected: false,
	},
	{
		name: 'PR',
		id: 4,
		selected: false,
	},
	{
		name: 'Customer Service',
		id: 5,
		selected: false,
	},
	{
		name: 'Tech',
		id: 6,
		selected: false,
	},
	{
		name: 'Other',
		id: 7,
		selected: false,
	},
];
